var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8889 0H3.11111C1.4 0 0 1.4 0 3.11111V24.8889C0 26.6 1.4 28 3.11111 28H24.8889C26.6 28 28 26.6 28 24.8889V3.11111C28 1.4 26.6 0 24.8889 0ZM14 4.66667C17.0022 4.66667 19.4444 7.10889 19.4444 10.1111C19.4444 13.1133 17.0022 15.5556 14 15.5556C10.9978 15.5556 8.55556 13.1133 8.55556 10.1111C8.55556 7.10889 10.9978 4.66667 14 4.66667ZM24.8889 24.8889H3.11111V24.5311C3.11111 23.5667 3.54667 22.6644 4.29333 22.0733C6.95333 19.9422 10.3289 18.6667 14 18.6667C17.6711 18.6667 21.0467 19.9422 23.7067 22.0733C24.4533 22.6644 24.8889 23.5822 24.8889 24.5311V24.8889Z",
    fill: "black",
    fillOpacity: 0.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.1e62e46f2ae23e2d290e445cc0b5f3cb.svg";
export { ForwardRef as ReactComponent };